import { useState, useEffect } from 'react';
import { makeGetCall } from '../utils/helper';

/**
 * Custom hook to fetch and cache site options
 * @returns {Object} { siteOptions, loading, error, refetch }
 */
export const useSites = () => {
  const [centers, setCenters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchSites = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await makeGetCall('/center-options');

      if (response?.data?.success) {
        setCenters(response.data.data || []);
      } else {
        throw new Error(response?.data?.message || 'Failed to fetch sites');
      }
    } catch (err) {
      console.error('Error fetching sites:', err);
      setError(err.message || 'Failed to fetch sites');

      // Fallback to hardcoded options if API fails (using your actual data format)
      setCenters([
        // { label: 'Somajiguda', value: 'smj' }
      ]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSites();
  }, []);

  const refetch = () => {
    fetchSites();
  };

  return {
    centers,
    loading,
    error,
    refetch
  };
};
